import React from 'react';

const LoadingAnimation = () => <div className='b-loading-animation'><div></div></div>;

export default LoadingAnimation;
